import { Component, OnInit, Input, OnChanges, SimpleChanges, OnDestroy } from '@angular/core';

import { Modal, BSModalContext } from 'angular2-modal/plugins/bootstrap';
import { overlayConfigFactory } from 'angular2-modal';

import { ViewKnowledgeLibraryModalComponent } from './library/view/view.component';

import { AuthService } from '../../../../../../providers/auth.service';
import { SharedHackService } from '../../../../shared/services/shared-hack.service';
import { ScreenTalentService } from '../../../screen-talent.service';

import { default as swal } from 'sweetalert2';
import { SortablejsOptions } from 'angular-sortablejs';
import { Subscription } from 'rxjs';
const MAX_TOTAL_WEIGHT: number = 100;


export class KnowledgeComponent implements OnInit, OnChanges, OnDestroy {
	 public set rootChallenges(ch) {
		const idx = this.challenges.findIndex((c) => c.edit_weight);
		if (idx > -1) {
			const newIdx = ch.findIndex((newCh) => newCh.id === this.challenges[idx].id);
			if (newIdx > -1) {
				ch[newIdx].edit_weight = true;
			}
		}

		this.challenges = [...ch];
		if (!this.library && this.challenges) {
			this.calculateTotalWeight();
		}

		this.sortableJsOptions = {
			...this.sortableJsOptions,
			disabled: !this.editable
		};
	}
	 public editable: boolean = false;
	 public library: boolean = false;
	 public create: boolean = false;
	 public hackId: string;
	 public test: any;
	 public visibility: string = 'public';

	public challenges = [];
	public totalWeight: number = 0;
	public sortableJsOptions: SortablejsOptions = {
		dragClass: 'dragged-elm',
		animation: 150,
		onStart: (event: any) => this.onStartDragElement(event),
		onUpdate: (event: any) => this.onDropElement(event)
	};

	public weightIsValid: boolean = false;
	public customValidationErr: string = null;
	public eventsSubscription: Subscription;

	private challengesRevertBackup = [];

	constructor(
		public modal: Modal,
		private authService: AuthService,
		private sharedHackService: SharedHackService,
		private screenTalentService: ScreenTalentService) { }

	// Lifecycle Events
	public ngOnInit(): void {
		this.sortableJsOptions.disabled = !this.editable;
		if (!this.library && this.challenges) {
			this.calculateTotalWeight();
		}

		this.eventsSubscription = this.screenTalentService.emitEventAction$.subscribe(
			(data) => {
				this.fetchEvent(data);
			}
		);
	}

	public ngOnChanges(changes: SimpleChanges) {
		if (changes.editable) {
			this.sortableJsOptions = {
				...this.sortableJsOptions,
				disabled: !changes.editable.currentValue
			};
		}
	}

	public ngOnDestroy(): void {
		if (this.eventsSubscription) {
			this.eventsSubscription.unsubscribe();
		}
	}

	// Events
	public onViewChallengeClick(challengeId: string): void {
		let data: any = { challengeId, fromLibrary: false, addedInChalenge: true, hackChallengeId: challengeId, editable: this.editable };
		let modalSettings: any = {
			size: 'lg',
			initData: data,
			isBlocking: false
		};
		this.modal.open(ViewKnowledgeLibraryModalComponent, overlayConfigFactory(modalSettings, BSModalContext))
			.then((result) => { result.result.then(() => undefined, () => undefined); });
	}

	public onDeleteChallengeClick(challengeId: string) {
		swal({
			title: 'Are you sure you want to remove this challenge from the test?',
			text: '',
			type: 'warning',
			showCancelButton: true,
			confirmButtonColor: '#E06160',
			confirmButtonText: 'Yes',
			cancelButtonText: 'No',
			allowOutsideClick: false,
			allowEscapeKey: false,
			reverseButtons: true
		}).then(() => {
			this.sharedHackService.deleteKnwoledgeTestQuestion(String(this.authService.userId), challengeId).subscribe(
				(resp) => {
					this.screenTalentService.emitEventAction({ component: 'summary', action: 'getHack', data: {} });
				}
			);
		}, () => undefined);
	}

	public onStartDragElement(event) {
		this.challengesRevertBackup = [...this.challenges];
	}

	public onDropElement(event) {
		const movedElm = this.challenges[event.newIndex];
		this.sortableJsOptions = {
			...this.sortableJsOptions,
			disabled: true
		};
		this.sharedHackService.updateKnowledgeTestProperties(String(this.authService.userId), movedElm.id, {priority: event.newIndex + 1}).subscribe(
			() => this.screenTalentService.emitEventAction({ component: 'summary', action: 'getHack', data: {} }),
			(err) => this.challenges = [...this.challengesRevertBackup]
		);
	}

	public changeWeight(challenge: any): void {
		challenge['edit_weight'] = null;
		this.sharedHackService.updateKnowledgeTestProperties(String(this.authService.userId), challenge.id, {weight: challenge.weight}).subscribe(
			() => undefined,
			() => undefined,
			() => this.screenTalentService.emitEventAction({ component: 'summary', action: 'getHack', data: {} })
		);
	}

	public onCloseWeightFormClick(challenge: any): void {
		this.closeWeightForm();
	}

	public onEditWeightClick(challenge: any): void {
		this.closeWeightForm();
		challenge['edit_weight'] = true;
	}

	public onChangePartialScoringClick(challenge, use: boolean) {
		this.sharedHackService.updateKnowledgeTestProperties(String(this.authService.userId), challenge.id, {is_accepting_partial_response: use}).subscribe(
			() => undefined,
			() => undefined,
			() => this.screenTalentService.emitEventAction({ component: 'summary', action: 'getHack', data: {} })
		);
	}
	public onChangeAllowCommentClick(challenge, use: boolean) {
		this.sharedHackService.updateKnowledgeTestProperties(String(this.authService.userId), challenge.id, {allow_comment: use}).subscribe(
			() => undefined,
			() => undefined,
			() => this.screenTalentService.emitEventAction({ component: 'summary', action: 'getHack', data: {} })
		);
	}

	public onWeightInputChange(value: number, challenge): void {
		this.calculateTotalWeight();
		if (value < 1) {
			if (challenge.type === 'textarea') {
				if (value === 0) {
					this.weightIsValid = true;
					this.customValidationErr = null;
				} else {
					this.weightIsValid = false;
					this.customValidationErr = 'Weight must be at least 0.';
				}
			} else {
				this.weightIsValid = false;
				this.customValidationErr = 'Weight must be grater then 0.';
			}
		} else if (this.totalWeight > MAX_TOTAL_WEIGHT) {
			this.weightIsValid = false;
			this.customValidationErr = 'Total weight exceded (max. 100).';
		} else {
			this.weightIsValid = true;
			this.customValidationErr = null;
		}
	}

	// Helpers
	private closeWeightForm() {
		this.challenges.forEach((item) => {
			item['edit_weight'] = null;
		});

		this.screenTalentService.emitEventAction({ component: 'summary', action: 'getHack', data: {} });
	}

	private calculateTotalWeight(): void {
		let total: number = 0;
		this.challenges.map((challenge) => {
			total += +challenge.weight;
		});
		this.totalWeight = total;
	}

	private fetchEvent(event: any): void {
		if (event.component && event.component === 'screen-talent' && event.action) {
			switch (event.action) {
				case 'publish-test':
					this.sortableJsOptions = {
						...this.sortableJsOptions,
						disabled: true
					};
					break;
				default:
					// code...
					break;
			}
		}
	}
static ctorParameters() { return [ { type: Modal }, { type: AuthService }, { type: SharedHackService }, { type: ScreenTalentService } ]; }}



// WEBPACK FOOTER //
// ./node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/components/client/screen-talent/test/summary/knowledge/knowledge.component.ts